import { Link } from "react-router-dom";

export default function CustomLink({ to, content, external, ...props }) {
  return (
    <>
      {external ? (
        <a
          href={to}
          style={{
            textDecoration: "none",
            color: "inherit",
          }}
          {...props}
        >
          {content}
        </a>
      ) : (
        <Link
          to={to}
          style={{
            textDecoration: "none",
            color: "inherit",
          }}
          {...props}
        >
          {content}
        </Link>
      )}
    </>
  );
}
